// Apply static merge tags to script content
export function applyStaticMergeTags(
  content: string,
  tags: Partial<{
    companyName: string;
    userName: string;
    userTitle: string;
    industry: string;
    businessType: string;
    businessHours: string;
    businessLocation: string;
    businessServices: string;
    [key: string]: string | undefined;
  }>
): string {
  const map: Record<string, string | undefined> = {
    '{{companyName}}': tags.companyName,
    '{{company_name}}': tags.companyName,
    '{{userName}}': tags.userName,
    '{{user_name}}': tags.userName,
    '{{userTitle}}': tags.userTitle,
    '{{user_title}}': tags.userTitle,
    '{{industry}}': tags.industry,
    '{{business_type}}': tags.businessType || tags.industry,
    '{{businessType}}': tags.businessType || tags.industry,
    '{{businessHours}}': tags.businessHours,
    '{{businessLocation}}': tags.businessLocation,
    '{{businessServices}}': tags.businessServices,
  };

  // Apply any additional context keys
  for (const [key, value] of Object.entries(tags)) {
    if (!map[`{{${key}}}`] && value) {
      map[`{{${key}}}`] = value;
    }
  }

  // Replace tags with values, global replace
  let result = content;
  for (const [tag, value] of Object.entries(map)) {
    if (typeof value === 'string' && value.length > 0) {
      result = result.split(tag).join(value);
    }
  }

  return result;
}
